import { LoginContainer } from "@/features/login";
import { createFileRoute } from "@tanstack/react-router";

type LoginStep = "OPENING" | "ID" | "PHONE_AUTH" | "RESET_PASSWORD";
type LoginSearch = {
	step: LoginStep;
};

export const Route = createFileRoute("/(non-auth)/login")({
	component: Login,
	validateSearch: (search: Record<string, unknown>): LoginSearch => {
		return {
			step: (search.step as LoginStep) || "OPENING"
		};
	}
});
function Login() {
	return <LoginContainer />;
}
